/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-2",
    "aws_cloud_logic_custom": [
        {
            "name": "AdminQueries",
            "endpoint": "https://1r6jl6io8c.execute-api.us-east-2.amazonaws.com/prod",
            "region": "us-east-2"
        }
    ],
    "aws_appsync_graphqlEndpoint": "https://lfnd4xh3evcjljncoenxzbm76e.appsync-api.us-east-2.amazonaws.com/graphql",
    "aws_appsync_region": "us-east-2",
    "aws_appsync_authenticationType": "API_KEY",
    "aws_appsync_apiKey": "da2-f4baqb6vzbdylnq7engxnh5egy",
    "aws_cognito_identity_pool_id": "us-east-2:897a0879-1645-4f77-a5dd-1d794037618f",
    "aws_cognito_region": "us-east-2",
    "aws_user_pools_id": "us-east-2_DXoPmljW8",
    "aws_user_pools_web_client_id": "e6o66cgubgp0r0kq6bs40puj3",
    "oauth": {},
    "federationTarget": "COGNITO_IDENTITY_POOLS",
    "aws_cognito_username_attributes": [
        "EMAIL",
        "PHONE_NUMBER"
    ],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_user_files_s3_bucket": "ticketingsystemadmina29b1f146cd8476b9f9aefcf325165037-prod",
    "aws_user_files_s3_bucket_region": "us-east-2"
};


export default awsmobile;
